import { __rest, __assign } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';

var CheckOutlineIcon = function (_a) {
    var title = _a.title, props = __rest(_a, ["title"]);
    return (jsxs("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", "data-ui-icon": true }, props, { children: [title ? jsx("title", { children: title }) : null, jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.954 15.733l10.635-10.08a1 1 0 011.376 0l.27.255a1 1 0 010 1.451L9.641 18.348a1 1 0 01-1.376 0l-5.5-5.214a1 1 0 010-1.451l.27-.256a1 1 0 011.375 0l4.543 4.306z", fill: "currentColor" })] })));
};

export { CheckOutlineIcon };
//# sourceMappingURL=CheckOutlineIcon.js.map
